import {inject,PLATFORM, customElement, bindable, bindingMode, computedFrom} from 'aurelia-framework';
import {I18N} from 'aurelia-i18n';
import {GroupService} from '../../../../../services/group/group-service';
import {DialogService} from 'aurelia-dialog';
import {AureliaConfiguration} from 'aurelia-configuration';

@inject(GroupService, I18N, DialogService, AureliaConfiguration)
@customElement('header-menu')
export class HeaderMenu {

  @bindable({
    defaultBindingMode: bindingMode.oneWay
  }) selectedGroup;

  buttonEl;
  visible = false;
  private __environment: string;

  constructor(private __groupService: GroupService, private __i18n: I18N, private __dialogControl: DialogService, auConfiguration: AureliaConfiguration) {
    // @ts-ignore
    this.__environment = auConfiguration.environment;
  }

  @computedFrom('selectedGroup')
  get menuData() {
    let menuData: any = {};
    menuData.data_admin = {
      items: [
        {
          icon: 'create-sub-group',
          label: this.__i18n.tr('groups.add_subgroup'),
          click: () => this.__groupService.createSubGroup(this.selectedGroup.id)
        }
        , {
          icon: 'add-members',
          label: this.__i18n.tr('groups.add_members'),
          click: () => this.__dialogControl.open({viewModel: PLATFORM.moduleName('resources/pagelayout/content/group/add-member/add-member'), model: this.selectedGroup.id})
        }
      ],
      separator: true,
      category: this.__i18n.tr('groups.category.admin'),
      display: () => {return this.selectedGroup.isGlobalAdmin}
    };

    menuData.data_group_member = {
      items: [
        {
          icon: 'make-group-default',
          label: this.__i18n.tr('groups.make_default'),
          click: () => this.__groupService.makeDefaultGroup(this.selectedGroup.id)
        }
      ],
      separator: true,
      category: this.__i18n.tr('groups.category.group-member'),
      display: () => {return this.selectedGroup.isGlobalAdmin || this.selectedGroup.isMember}
    };

    menuData.data_other = {
      items: [
        {
          icon: 'request-affiliation',
          label: this.__i18n.tr('groups.affiliate'),
          click: () => this.__groupService.affiliateWith(this.selectedGroup.id)
        }
      ],
      category: this.__i18n.tr('groups.category.other'),
      display: () => {return true}
    };

    return menuData;
  }


}
